import { action, computed, makeAutoObservable } from "mobx";
import { BACKEND_URL } from "../constants";

export class BackendStore {
  // TODO(HUT): make constants.ts
  private backend: string = BACKEND_URL;

  constructor() {
    makeAutoObservable(this);
  }

  @computed
  get(): string {
    return this.backend;
  }

  @action
  set(newBackend: string): void {
    this.backend = newBackend;
  }

  @action
  clear(): void {
    this.backend = "";
  }
}
